import React from "react";

import {
  FiArrowLeft,
  FiChevronRight,
  FiSearch,
} from "react-icons/fi";

const BankSelectionPage = ({
  bankSearch,
  setBankSearch,

  POPULAR_BANKS,
  filteredBanks,

  setSelectedBankId,
  setScreen,
}) => {
  return (
    <section className="fw-screen fw-screen--bank fw-fade">
      <div className="fw-bank-top">
        <button
          type="button"
          className="fw-bank-back"
          onClick={() => setScreen("/apply-new/processBank")}
          aria-label="Back"
        >
          <FiArrowLeft />
        </button>

        <h1>Select your Bank testd</h1>
      </div>

      <label className="fw-bank-search">
        <FiSearch />

        <input
          value={bankSearch}
          placeholder="Search bank name"
          onChange={(e) => setBankSearch(e.target.value)}
        />
      </label>

      <div className="fw-bank-scroll">
        <h2>Popular Banks</h2>

        <div className="fw-bank-grid">
          {POPULAR_BANKS
            .filter((bank) =>
              bank.name
                .toLowerCase()
                .includes(bankSearch.trim().toLowerCase())
            )
            .map((bank) => (
              <button
                key={bank.id}
                type="button"
                className="fw-bank-card"
                onClick={() => {
                  setSelectedBankId(bank.id);
                  setScreen("/apply-new/connectBank");
                }}
              >
                <span
                  className="fw-bank-logo"
                  style={{ background: bank.color }}
                >
                  {bank.name.charAt(0)}
                </span>

                <small>{bank.name}</small>
              </button>
            ))}
        </div>

        <h2>All Banks</h2>

        <div className="fw-bank-list">
          {filteredBanks.map((bank) => (
            <button
              key={`all-${bank.id}`}
              type="button"
              className="fw-bank-row"
              onClick={() => {
                setSelectedBankId(bank.id);
                setScreen("/apply-new/connectBank");
              }}
            >
              <span
                className="fw-bank-logo fw-bank-logo--sm"
                style={{ background: bank.color }}
              >
                {bank.name.charAt(0)}
              </span>

              <span>{bank.name}</span>

              <FiChevronRight />
            </button>
          ))}
        </div>
      </div>

      <p className="fw-powered">
        Powered by <b>FUNDSWALLE</b>
      </p>
    </section>
  );
};

export default BankSelectionPage;